import { startCase } from "lodash";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import {
  formatValueDynamically,
  getFormattedValue,
} from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

type MemberProfileParams = {
  name?: string;
  member_tags?: string;
  admin?: boolean;
  is_flagged?: boolean;
  messaging_disabled?: boolean;
} & Record<string, string | number | boolean | string[] | undefined>;

export type MemberProfileFieldKey =
  | "name"
  | "member_tags"
  | "admin"
  | "is_flagged"
  | "messaging_disabled";

interface MemberProfileFieldConfig {
  label: string;
  type: "string" | "boolean";
}

export const MEMBER_PROFILE_FIELDS: Record<
  MemberProfileFieldKey,
  MemberProfileFieldConfig
> = {
  name: {
    label: t("account.member_edit_profile_form.name"),
    type: "string",
  },
  member_tags: {
    label: t("account.member_edit_profile_form.member_tags_label"),
    type: "string",
  },
  admin: {
    label: t("account.member_edit_profile_form.admin"),
    type: "boolean",
  },
  is_flagged: {
    label: t("account.member_edit_profile_form.is_flagged"),
    type: "boolean",
  },
  messaging_disabled: {
    label: t("account.member_edit_profile_form.messaging_disabled"),
    type: "boolean",
  },
};

interface MemberProfileCardProps {
  params: MemberProfileParams;
  url: string;
}

export const MemberProfileCard = ({ params, url }: MemberProfileCardProps) => {
  const fieldEntries = Object.entries(MEMBER_PROFILE_FIELDS) as Array<
    [MemberProfileFieldKey, MemberProfileFieldConfig]
  >;

  return (
    <PreviewCardLayout
      title={t("help_widget.copilot.preview_cards.member_profile_card_title")}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {fieldEntries.map(([key, keyProps]) => {
          const value = params[key];

          if (value == null) return null;

          return (
            <li key={key} className="text-darkest !pb-0">
              <Typography.BodySm color="text-darkest">
                <strong>{keyProps.label}:</strong>{" "}
                {getFormattedValue(value, keyProps.type)}
              </Typography.BodySm>
            </li>
          );
        })}
        {Object.entries(params)
          .filter(
            ([key, value]) =>
              !((key as MemberProfileFieldKey) in MEMBER_PROFILE_FIELDS) &&
              value != null,
          )
          .map(([key, value]) => {
            if (value == null) return null;

            const displayValue = value;

            return (
              <li key={key} className="text-darkest !pb-0">
                <Typography.BodySm color="text-darkest">
                  <strong>{startCase(key)}:</strong>{" "}
                  {formatValueDynamically(displayValue)}
                </Typography.BodySm>
              </li>
            );
          })}
      </ul>
    </PreviewCardLayout>
  );
};
